export default __webpack_public_path__ + "static/media/49046c1aec1e3911f7c4d2ef465cb4f9.png";